module.exports = __webpack_public_path__ + "static/media/order.79652578.svg";